/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlDetectionListItem } from './ControlDetectionListItem';
import {
    ControlDetectionListItemFromJSON,
    ControlDetectionListItemFromJSONTyped,
    ControlDetectionListItemToJSON,
} from './ControlDetectionListItem';

/**
 * 
 * @export
 * @interface ControlDetectionsList
 */
export interface ControlDetectionsList {
    /**
     * 
     * @type {Array<ControlDetectionListItem>}
     * @memberof ControlDetectionsList
     */
    data: Array<ControlDetectionListItem>;
}

/**
 * Check if a given object implements the ControlDetectionsList interface.
 */
export function instanceOfControlDetectionsList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ControlDetectionsListFromJSON(json: any): ControlDetectionsList {
    return ControlDetectionsListFromJSONTyped(json, false);
}

export function ControlDetectionsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDetectionsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ControlDetectionListItemFromJSON)),
    };
}

export function ControlDetectionsListToJSON(value?: ControlDetectionsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ControlDetectionListItemToJSON)),
    };
}

